import React from 'react';
import { Fragment } from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';

const StyledBold = styled.b`
  font-family: 'Circular-Bold';
`;

const StyledP = styled.p`
  text-align: center;
`;

const FileErrorBreakdown = ({ fileName, mimeType }) => (
  <Fragment>
    <StyledP>
      <StyledBold>{fileName}</StyledBold>{' '}
      {getTranslatedString('tenantPortal.fileErrorBreakdown.body')}{' '}
      <StyledBold>.{mimeType}</StyledBold>
    </StyledP>
  </Fragment>
);

export default FileErrorBreakdown;
